import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

export const RefreshIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="seaport-icon"
      viewBox="0 0 18 16"
    >
      <path
        fill={fill || '#7E8A96'}
        d="M10.282 7.367l-.124-1.329 1.688-.138a3.67 3.67 0 00-2.467-.933c-1.964 0-3.555 1.492-3.555 3.333 0 1.841 1.591 3.333 3.555 3.333 1.295 0 2.428-.648 3.05-1.618l1.424.334c-.81 1.55-2.509 2.618-4.474 2.618-2.749 0-4.978-2.09-4.978-4.667S6.63 3.633 9.38 3.633c1.384 0 2.636.53 3.539 1.385l-.175-1.869 1.417-.116.372 3.985-4.25.349z"
      />
    </svg>
  );
};

export default RefreshIcon;
